import styled from 'styled-components';
import Flex from '../../atoms/Flex';
export const Container = styled(Flex)`
  display: flex;
  align-content: center;
  justify-content: ${({
  carousel
}) => carousel ? 'start' : 'center'};
  padding: 12px;
  overflow-x: ${({
  scrollOff
}) => scrollOff ? 'hidden' : 'scroll'};
`;
export const DeliveryContainer = styled(Flex)`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
`;